(function () {
  const container = document.currentScript.parentElement;
  const next = document.currentScript.parentElement.parentElement.querySelector('.swiper-button-next')
  const prev = document.currentScript.parentElement.parentElement.querySelector('.swiper-button-prev')



  const swiper = new Swiper(container, {
    slidesPerView: 3,
    spaceBetween: 8,
    navigation: {
      nextEl: next,
      prevEl: prev,
    },
  })

  function positionArrows() {
    const heightOfSlide = container.querySelector('.swiper-slide img').offsetHeight
    next.style.top = `${(heightOfSlide / 2) + 10}px`
    prev.style.top = `${(heightOfSlide / 2) + 10}px`
  }

  positionArrows()

  window.addEventListener('resize', positionArrows)

})();